import { fetchViewable } from 'api';
import useAxios from 'hooks/useAxios';

const useFetchViewable = () => {
  const [request, { loading, error }] = useAxios<any>();

  const handleFetchViewable = async (objectName: string, bucketName: string) => {
    const viewable = await request(fetchViewable({ objectName, bucketName }));

    return viewable;
  };

  return [handleFetchViewable, { loading, error: error?.data?.message }] as const;
};

export { useFetchViewable };
